import {createStore} from "vuex"

//创建store实例
const store=createStore({
    state(){
        return {
            "windowWidth":0,
            "theme":'',
            "module":"",
            "portalInfo":{},
              mapData:{
                data:[],
                mouseLocation: [0, 0],
                zoom: 13,
                range: [0, 0],
            },
            mapMes:{},
        }
    },
    mutations:{
      widthChange(state,width) {
        // 变更状态
        state.windowWidth = width
      },
      setTheme(state,theme) {
        // 变更状态
        console.log(theme)
        state.theme = theme
      },
      setModule(state,module) {
        // 变更状态
        state.module = module
      },
      setPortalInfo(state,data) {
        // 变更状态
        state.portalInfo = data;
      },
      mapDataChange (state, data) {
            state.mapData.data = data
        },
        mapConfigChange (state, data) {
            state.mapData.mouseLocation = [Number(data.mouseLocation[0].toFixed(5)),Number(data.mouseLocation[1].toFixed(5))]
            state.mapData.zoom = data.zoom
            state.mapData.range = data.range
        },
        mapMesChange (state, data) {
            state.mapMes = data
        },
    }
})
export default store;